var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.description)?_c('div',{class:{
      'dh-psy-data-viz__description-item': true,
      'dh-psy-data-viz__description-item--left': _vm.align === 'left',
      'dh-psy-data-viz__description-item--right': _vm.align === 'right'
    }},[(_vm.altText)?_c('span',{staticClass:"nrk-sr",domProps:{"innerHTML":_vm._s(_vm.altText)}}):_vm._e(),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }